import PropTypes from 'prop-types';
import React, { useState, useRef, useEffect } from 'react';
import HoldingStatusIcon from 'components/atoms/icons/holdingStatusIcon';
import dataService from 'services/dataService';
import { apiPatientHoldingStatus } from 'services/dataService/resources';
import forms from 'constants/forms';
import { showResult } from 'utils';
import common from 'constants/common';
import { intervalToDuration, addDays } from 'date-fns';
import classnames from 'classnames';
import ControlPanelButton from '../controlPanelButton';
import UpdatePatientHoldingStatusModal from './updatePatientHoldingStatusModal';
import { parseDateSafe } from '../../../utils/timeHelper';

const { patientHoldingStatus: statuses } = common;
const formatLeftDays = (status) => {
  const statusName = statuses[status?.currentStatus];

  if (statusName && statusName !== statuses.active) {
    const today = new Date();
    const endDate = parseDateSafe(status?.endTime);
    const remainingDays = intervalToDuration({
      start: today,
      end: endDate,
    })?.days;

    return (
      <>
        <span className="holding-status__name">{statusName}</span>{' '}
        <span className="holding-status__days">({remainingDays + 1} days)</span>
      </>
    );
  }
};

const options = forms.patientHoldingStatuses;
const PatientHoldingStatus = ({
  patientGuid,
  holdingStatus,
  isAdminPage,
  patientDetailsLoading,
  disabled = false,
  isCcmPage,
}) => {
  const [holdingStatusPopup, setHoldingStatusPopup] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [currentHoldingStatus, setCurrentHoldingStatus] = useState(null);

  const buttonRef = useRef();

  const distanceFromLeftViewport =
    buttonRef?.current?.getBoundingClientRect().left;

  useEffect(() => {
    const mappedHoldingStatus = holdingStatus
      ? {
          currentStatus: holdingStatus.status,
          endTime: holdingStatus.endTime,
        }
      : null;
    setCurrentHoldingStatus(mappedHoldingStatus);
  }, [patientDetailsLoading]);
  const submitHoldingStatus = async (postData) => {
    setUpdateLoading(true);
    const { error } = await dataService.createOne(
      apiPatientHoldingStatus(patientGuid),
      postData,
    );

    if (error) {
      setHoldingStatusPopup(false);
      setUpdateLoading(false);
      showResult(error);
    }

    setCurrentHoldingStatus({
      currentStatus: postData.holdingStatus,
      endTime: addDays(new Date(), postData.days),
    });
    setUpdateLoading(false);
  };

  return (
    <>
      <div
        ref={buttonRef}
        className={classnames(
          { 'admin-patient-header-actions-call': isAdminPage },
          'holding-status',
          {
            expand:
              currentHoldingStatus?.currentStatus &&
              currentHoldingStatus.currentStatus !== 'active',
            'popup-stick-left':
              distanceFromLeftViewport && distanceFromLeftViewport < 450,
          },
        )}
      >
        <ControlPanelButton
          label="Holding Status"
          icon={HoldingStatusIcon}
          status={formatLeftDays(currentHoldingStatus)}
          handleClick={() => setHoldingStatusPopup(true)}
          disabled={disabled}
        />
        {holdingStatusPopup && (
          <UpdatePatientHoldingStatusModal
            isOpen={holdingStatusPopup}
            toggle={setHoldingStatusPopup}
            options={options}
            patientGuid={patientGuid}
            patientHoldingStatus={currentHoldingStatus?.currentStatus}
            patientHoldingStatusLoading={updateLoading}
            loading={false}
            submit={submitHoldingStatus}
            isCcmPage={isCcmPage}
          />
        )}
      </div>
    </>
  );
};

PatientHoldingStatus.propTypes = {
  patientGuid: PropTypes.string,
  holdingStatus: PropTypes.object,
  isAdminPage: PropTypes.bool,
  isCcmPage: PropTypes.bool,
  patientDetailsLoading: PropTypes.bool,
  disabled: PropTypes.bool.isRequired,
};

export default PatientHoldingStatus;
